<div class="kt-footer  kt-footer--extended  kt-grid__item" id="kt_footer">
    <div class="kt-footer__bottom fixed-bottom footer-upm">
        <div [class]="containerClass">
            <div class="kt-footer__wrapper">
                
            </div>
            <div class="text-center">
                <span class="m-footer__copyright">
                    UPM | &copy; {{today | date:'yyyy'}}
                </span>
            </div>
        </div>
    </div>
</div>
